import { Map } from 'immutable';
import {
    NOTICE_GET_OVERVIEW,
    NOTICE_SET_OVERVIEW,
    NOTICE_GET_ALL_MANUAL_TYPE,
} from '../actions/notice';
import { APP_RESET } from '../actions/reset';
import { createActionHandler, createAsyncActionHandler } from './creator';

const initial = Map({
    isLoading: true,
    noticeOverview: { data: [], totalCounts: 0 },
    allManualType: [],
});

const handlers = {
    ...createActionHandler(APP_RESET, () => initial),

    // 获取预览消息列表
    ...createAsyncActionHandler(NOTICE_GET_OVERVIEW, {
        init: (state: any) => state,
        succeeded: (state: any, action: Action.Sync) =>
            state.merge({
                isLoading: false,
                noticeOverview: action.payload,
            }),
        failed: (state: any, action: Action.Sync) =>
            state.merge({
                isLoading: true,
                noticeOverview: action.payload,
            }),
    }),

    // 设置预览消息列表
    ...createAsyncActionHandler(NOTICE_SET_OVERVIEW, {
        init: (state: any) => state,
        succeeded: (state: any, action: Action.Sync) =>
            state.merge({
                noticeOverview: action.payload,
            }),
        failed: (state: any, action: Action.Sync) =>
            state.merge({
                noticeOverview: action.payload,
            }),
    }),

    // 获取含有子级的所有通知类型列表
    ...createAsyncActionHandler(NOTICE_GET_ALL_MANUAL_TYPE, {
        init: (state: any) => state,
        succeeded: (state: any, action: Action.Sync) =>
            state.merge({
                allManualType: action.payload,
            }),
        failed: (state: any, action: Action.Sync) =>
            state.merge({
                allManualType: action.payload,
            }),
    }),
};

export const notification = initial;
export default (state = notification, action: any = {}): any => {
    const fn = handlers[action.type];
    return fn ? fn(state, action) : state;
};
